import { render, staticRenderFns } from "./PendingNCF.vue?vue&type=template&id=6c94e60e&scoped=true&"
import script from "./PendingNCF.vue?vue&type=script&lang=js&"
export * from "./PendingNCF.vue?vue&type=script&lang=js&"
import style0 from "./PendingNCF.vue?vue&type=style&index=0&id=6c94e60e&prod&lang=scss&scoped=true&"
import style1 from "./PendingNCF.vue?vue&type=style&index=1&id=6c94e60e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94e60e",
  null
  
)

export default component.exports